var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { STATIC_ASSETS_BASE } from './constants';
import favicons from './favicons';
var links = __spreadArray(__spreadArray([], favicons, true), [
    // PWA web manifest
    {
        rel: 'manifest',
        href: "".concat(STATIC_ASSETS_BASE, "/manifest.json"),
    },
    // OpenSearch
    {
        rel: 'search',
        type: 'application/opensearchdescription+xml',
        title: 'Redbubble Search',
        href: "".concat(STATIC_ASSETS_BASE, "/opensearch.xml"),
    },
], false);
export default links;
